import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Dependencies from "./Dependencies";
import Projects from "./Projects";

export default function LicenseInfo({projects, dependencies}) {
    return (
        <Box style={{backgroundColor:'#fff'}} sx={{ flexGrow: 1 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Dependencies data={dependencies}/>
                </Grid>
                {/*<Grid item xs={4}>*/}
                {/*    <Projects data={projects}/>*/}
                {/*</Grid>*/}
            </Grid>
        </Box>
    );
}